// PaginationList
import React from 'react';
import PropTypes from 'prop-types';

const PaginationList = props => (
  <ul className="pagination blog-pagination justify-content-center align-items-center flex-nowrap gap-1 gap-md-2 w-100 mt-3 mb-0">
    <li className={`page-item ${(props.pager.currentPage === 1 ? 'disabled' : '')}`}>
      <button type="button" className="page-link rounded-circle first-button" onClick={() => props.setPage(1)} aria-label="First page"><span className="first-button-text">&lt;&lt;</span></button>
    </li>
    <li className={`page-item ${(props.pager.currentPage === 1 ? 'disabled' : '')}`}>
      <button type="button" className="page-link rounded-circle previous-button" onClick={() => props.setPage(props.pager.currentPage - 1)} aria-label="Previous page"><span className="previous-button-text">&lt;</span></button>
    </li>
    {props.pager.pages.map(page => (
      <li key={page} className={`page-item ${(props.pager.currentPage === page ? 'active' : '')}`}>
        <button type="button" className={`page-link rounded-circle ${page}-button`} onClick={() => props.setPage(page)} aria-label={`Page ${page}`} aria-current={props.pager.currentPage === page ? 'page' : undefined}><span className={`${page}-button-text`}>{page}</span></button>
      </li>
    ))}
    <li className={`page-item ${(props.pager.currentPage === props.pager.totalPages ? 'disabled' : '')}`}>
      <button type="button" className="page-link rounded-circle next-button" onClick={() => props.setPage(props.pager.currentPage + 1)} aria-label="Next page"><span className="next-button-text">&gt;</span></button>
    </li>
    <li className={`page-item ${(props.pager.currentPage === props.pager.totalPages ? 'disabled' : '')}`}>
      <button type="button" className="page-link rounded-circle last-button" onClick={() => props.setPage(props.pager.totalPages)} aria-label="Last page"><span className="last-button-text">&gt;&gt;</span></button>
    </li>
  </ul>
);

PaginationList.propTypes = {
  setPage: PropTypes.func.isRequired,
  pager: PropTypes.shape({
    totalItems: PropTypes.number,
    currentPage: PropTypes.number,
    pageSize: PropTypes.number,
    totalPages: PropTypes.number,
    startPage: PropTypes.number,
    endPage: PropTypes.number,
    startIndex: PropTypes.number,
    endIndex: PropTypes.number,
    pages: PropTypes.number,
  }),
};

export default PaginationList;
